import { IGoogleFont, TGoogleFontCategory } from './briefFontSelection.types'

const sortGoogleFonts = (fonts: IGoogleFont[]) => {
  const sortedGoogleFonts: Record<TGoogleFontCategory, IGoogleFont[]> = {
    all: [],
    'sans-serif': [],
    serif: [],
    display: [],
    handwriting: [],
    monospace: [],
  }

  for (const font of fonts) {
    sortedGoogleFonts[font.category].push(font)
  }
  sortedGoogleFonts.all = fonts

  return sortedGoogleFonts
}

const filterFonts = (fontsToFilter: IGoogleFont[], filter: string) => {
  const filterParts = filter
    .toLowerCase()
    .split(' ')
    .filter((filterPart) => Boolean(filterPart))

  return fontsToFilter?.filter((font) => {
    return filterParts.some((filterPart) =>
      font?.family?.toLowerCase().includes(filterPart)
    )
  })
}

export { sortGoogleFonts, filterFonts }
